import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { X } from "react-feather";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import styles from "./vehicledetail.module.css";
import { apiErrorMessage } from "./vehicleRequestUtils";
import { unitLabel } from "../public/publicVehicleApi";

const MAX_REASON = 500;

// Reject a pending vehicle request with a reason (sent to the tenant, and by SMS to a guest)
const RejectVehicleDialog = ({ open, requestId, plate, name, property, unit, onClose, onRejected, notifySuccess }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const submit = async () => {
    const text = reason.trim();
    if (text === "" || !requestId) return;

    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await axios.post(process.env.REACT_APP_TENANT_API_URL + "v1/vehicle-requests/" + requestId + "/reject", { reason: text }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (notifySuccess) notifySuccess(response?.data?.message || "Vehicle rejected.");
      if (onRejected) onRejected();
    } catch (error) {
      console.error("[Vehicles] Failed to reject vehicle request", error);
      toast.error(apiErrorMessage(error, "Unable to reject the vehicle. Please try again."));
    } finally {
      setSubmitting(false);
    }
  };

  const location = [property, unitLabel(unit)].filter(Boolean).join(", ");

  return (<Dialog open={Boolean(open)} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm" className="NewPopUp">
    <DialogTitle>
      Reject vehicle {plate || ""}?
      <button type="button" onClick={onClose} disabled={submitting}><X /></button>
    </DialogTitle>
    <DialogContent>
      <p className={styles.RejectSubtitle}>
        {[name, location].filter(Boolean).join(" · ")}{name || location ? ". " : ""}The tenant (and guest, for a guest vehicle) can edit and resubmit.
      </p>
      <label htmlFor="reject-reason" className={styles.RejectLabel}>REASON FOR REJECTION *</label>
      <textarea
        id="reject-reason"
        className={styles.RejectTextarea}
        rows={4}
        maxLength={MAX_REASON}
        value={reason}
        disabled={submitting}
        onChange={(e) => setReason(e.target.value)}
      />
      <div className={styles.RejectHelpRow}>
        <span>Sent to the tenant in the app. For a guest vehicle, the guest also gets it by SMS.</span>
        <span>{reason.length} / {MAX_REASON}</span>
      </div>
    </DialogContent>
    <DialogActions>
      <button type="button" className={styles.BtnGhost} disabled={submitting} onClick={onClose}>Cancel</button>
      <button type="button" className={styles.BtnDanger} disabled={submitting || reason.trim() === ""} onClick={submit}>
        {submitting ? "Rejecting..." : "Reject vehicle"}
      </button>
    </DialogActions>
  </Dialog>);
};

export default RejectVehicleDialog;
